import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGlobe,
  faBuilding,
  faRobot,
  faStar,
  faCheckCircle,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import './style.css';

const benefitsSection = [
  {
    title: "Your Dream Website, Made Real",
    icon: faGlobe,
    description: "Turn your vision into reality with a stunning website that attracts customers and grows your business."
  },
  {
    title: "Professional Look That Builds Trust",
    icon: faBuilding,
    description: "Stand out from competitors with a polished, credible website that makes customers choose you."
  },
  {
    title: "Works Perfect on Every Device",
    icon: faRobot,
    description: "Your customers will love browsing your site whether they're on phone, tablet, or computer."
  },
  {
    title: "Found Easily on Google",
    icon: faCheckCircle,
    description: "Get discovered by more customers with a website built to rank high in search results."
  },
  {
    title: "Lightning Fast Loading",
    icon: faStar,
    description: "Keep visitors engaged with a website that loads instantly - no more losing customers to slow sites."
  },
  {
    title: "We're Here When You Need Us",
    icon: faUsers,
    description: "Get friendly, expert help whenever you have questions. No tech jargon, just real solutions."
  }
];

function BenefitsSection() {
  return (
    <section className="benefits-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="benefits-title">
            Why Your Business Needs a Great Website
          </h2>
          <div className="benefits-lead">
            Everything you need to attract more customers and grow your business online.
          </div>
        </div>
        <Row className="text-center">
          {benefitsSection.map((feature, index) => (
            <Col key={index} xs="12" sm="6" md="4" className="mb-4">
              <div className="benefits-card" tabIndex={0}>
                <div
                  className="benefits-icon"
                  title={feature.description}
                  aria-label={feature.description}
                >
                  <FontAwesomeIcon
                    icon={feature.icon}
                    size="3x"
                  />
                </div>
                <h5 className="benefits-card-title">
                  {feature.title}
                </h5>
                <div className="benefits-card-desc">
                  {feature.description}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default BenefitsSection;
